import React from 'react';
import Button, { ButtonProps } from 'atoms/Button/Button';
import { TypographyProps } from 'atoms/Typography/Typography';
import FeaturedIcon, { FeaturedIconProps } from 'molecules/FeaturedIcon/FeaturedIcon';
import Stack from 'atoms/Layout/Stack/Stack';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';

export interface FeaturedIconCardProps {
  heading: TypographyProps;
  supportingText: TypographyProps;
  featuredIcon: FeaturedIconProps;
  buttonProps?: ButtonProps;
}

const FeaturedIconCard = ({
  heading,
  supportingText,
  featuredIcon,
  buttonProps,
}: FeaturedIconCardProps): JSX.Element => (
  <Stack
    borderRadius='radius-2xl'
    background='bg-secondary'
    overflow='hidden'
    padding='spacing-3xl'
    paddingSm='spacing-2xl'
    direction='column'
    justify='flex-start'
    align='flex-start'
    gap='spacing-7xl'
    gapSm='spacing-6xl'
  >
    <FeaturedIcon {...featuredIcon} />
    <Stack
      direction='column'
      justify='flex-start'
      align='flex-start'
      gap='spacing-xl'
    >
      <HeadingAndSupportingText
        heading={heading}
        supportingText={supportingText}
        gap='spacing-xs'
      />
      {buttonProps && (
        <Stack>
          <Button {...buttonProps} />
        </Stack>
      )}
    </Stack>
  </Stack>
);

export default FeaturedIconCard;
